import { Menu } from "antd";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useMemo } from "react";
import { Outlet, useLocation } from "react-router";
import { NavLink } from "react-router-dom";

import { RequestAccessModalButton } from "./Modal/RequestAccessModalButton";
import { JitPaths } from "./paths";

const item = (path: string, label: string) => ({
  key: path,
  label: <NavLink to={path}>{label}</NavLink>,
});

export const Jit: React.FC<object> = () => {
  const { pathname } = useLocation();
  const flags = useFlags();

  const selected = useMemo(
    () => pathname.split("/").at(-1) ?? "requests",
    [pathname]
  );

  const navItems = [item(JitPaths.Activity, "Activity")];

  if (flags.showEvidenceStore) {
    navItems.push(item(JitPaths.PreApprovals, "Pre Approvals"));
  }

  navItems.push(item(JitPaths.History, "History"));

  if (flags.showExperimentalWebShell) {
    navItems.push(item(JitPaths.Shell, "Shell"));
  }

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: "1em",
          borderBottom: "1px solid #e8e8e8",
          marginBottom: "1em",
        }}
      >
        <Menu
          mode="horizontal"
          items={navItems}
          selectedKeys={[selected]}
          style={{
            borderBottom: "none",
            flexGrow: 1,
          }}
        />
        <RequestAccessModalButton />
      </div>
      <Outlet />
    </>
  );
};
